import { render } from "./OsisRefWidget.vue?vue&type=template&id=576f46da&scoped=true"
import script from "./OsisRefWidget.vue?vue&type=script&lang=js"
export * from "./OsisRefWidget.vue?vue&type=script&lang=js"

import "./OsisRefWidget.vue?vue&type=style&index=0&id=576f46da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576f46da"]])

export default __exports__